import { render, staticRenderFns } from "./Codeconfig.vue?vue&type=template&id=3e328e0f&scoped=true"
import script from "./Codeconfig.vue?vue&type=script&lang=js"
export * from "./Codeconfig.vue?vue&type=script&lang=js"
import style0 from "./Codeconfig.vue?vue&type=style&index=0&id=3e328e0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e328e0f",
  null
  
)

export default component.exports